export const targeting = {
  AgeGenderAudienceReport: {
    mandatory: [
      'AgeGroup',
      'Gender',
    ],
    default: [
      'AccountName',
      'CampaignName',
      'AdGroupName',
      'AdDistribution',
      'AgeGroup',
      'Gender',
      'Impressions',
      'TopImpressionRatePercent',
      'AbsoluteTopImpressionRatePercent',
      'Clicks',
      'Conversions',
      'Spend',
    ],
  },
  ProfessionalDemographicsAudienceReport: {
    mandatory: [
      'AccountName',
      'CompanyName',
      'IndustryName',
      'JobFunctionName',
    ],
    default: [
      'AccountName',
      'CampaignName',
      'AdGroupName',
      'CompanyName',
      'IndustryName',
      'JobFunctionName',
      'AdDistribution',
      'Impressions',
      'Clicks',
      'Conversions',
      'Spend',
      'AveragePosition',
      'TopImpressionRatePercent',
      'AbsoluteTopImpressionRatePercent',
    ],
  },
  UserLocationPerformanceReport: {
    mandatory: [],
    default: [
      'AccountName',
      'Country',
      'State',
      'MetroArea',
      'City',
      'Impressions',
      'Clicks',
      'CTR',
      'AverageCPC',
      'Spend',
      'Conversions',
      'TopImpressionRatePercent',
      'AbsoluteTopImpressionRatePercent',
      'AssetGroupName',
    ],
  },
  GeographicPerformanceReport: {
    mandatory: [],
    default: [
      'AccountName',
      'Country',
      'State',
      'MetroArea',
      'City',
      'LocationType',
      'MostSpecificLocation',
      'Impressions',
      'Clicks',
      'CTR',
      'AverageCPC',
      'Spend',
      'Conversions',
      'TopImpressionRatePercent',
      'AbsoluteTopImpressionRatePercent',
      'AssetGroupName',
    ],
  },
  GenrePerformanceReport: {
    mandatory: [],
    default: [
      'AccountName',
      'AccountId',
      'AccountNumber',
      'CampaignName',
      'CampaignId',
      'AdGroupName',
      'AdGroupId',
      'Genre',
      'Impressions',
      'Spend',
      'AverageCPM',
      'AverageCPV',
      'VideoViewsAt25Percent',
      'VideoViewsAt50Percent',
      'VideoViewsAt75Percent',
      'CompletedVideoViews',
      'VideoCompletionRate',
    ],
  },
};
